// import React from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   CircularProgress,
//   Box,
//   Typography,
// } from '@mui/material';

// const CreateCustomerDialog = ({
//   open,
//   selectedLead,
//   processing,
//   onClose,
//   onSubmit,
// }) => {
//   const [formData, setFormData] = React.useState({
//     name: '',
//     email: '',
//     password: '',
//   });

//   // Pre-fill form with lead data when dialog opens
//   React.useEffect(() => {
//     if (selectedLead && open) {
//       setFormData({
//         name: selectedLead.name || '',
//         email: selectedLead.email || '',
//         password: generatePassword(), // Auto-generate password
//       });
//     }
//   }, [selectedLead, open]);

//   const generatePassword = () => {
//     // Generate a random password
//     const length = 12;
//     const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
//     let password = "";
//     for (let i = 0; i < length; i++) {
//       password += charset.charAt(Math.floor(Math.random() * charset.length));
//     }
//     return password;
//   };

//   const handleChange = (field) => (event) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: event.target.value
//     }));
//   };

//   const handleRegeneratePassword = () => {
//     setFormData(prev => ({
//       ...prev,
//       password: generatePassword()
//     }));
//   };

//   const handleSubmit = () => {
//     // Prepare payload with hidden flag
//     const payload = {
//       ...formData,
//       flag: 'lead_customer',
//       lead_id: selectedLead?.id
//     };
//     console.log("click hai");
    
//     onSubmit(payload);
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>Create Customer from Lead</DialogTitle>
//       <DialogContent>
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
//           <TextField
//             label="Customer Name"
//             value={formData.name}
//             onChange={handleChange('name')}
//             fullWidth
//             required
//           />
          
//           <TextField
//             label="Email"
//             type="email"
//             value={formData.email}
//             onChange={handleChange('email')}
//             fullWidth
//             required
//           />
          
//           <Box>
//             <TextField
//               label="Password"
//               value={formData.password}
//               onChange={handleChange('password')}
//               fullWidth
//               required
//             />
//             <Button 
//               onClick={handleRegeneratePassword}
//               size="small"
//               sx={{ mt: 1 }}
//             >
//               Regenerate Password
//             </Button>
//           </Box>

//           {/* <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//             This will create a customer account with the flag "lead_customer"
//           </Typography> */}
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={!formData.name || !formData.email || !formData.password || processing}
//           startIcon={processing ? <CircularProgress size={20} /> : null}
//         >
//           Create Customer
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default CreateCustomerDialog;

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';

const CreateCustomerDialog = ({
  open,
  selectedLead,
  processing,
  onClose,
  onSubmit,
}) => {
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    password: '',
  });

  // Pre-fill form with lead data when dialog opens
  React.useEffect(() => {
    if (selectedLead && open) {
      setFormData({
        name: selectedLead.name || '',
        email: selectedLead.email || '',
        password: generatePassword(), // Auto-generate password
      });
    }
  }, [selectedLead, open]);

  const generatePassword = () => {
    const length = 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  };

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleRegeneratePassword = () => {
    setFormData((prev) => ({
      ...prev,
      password: generatePassword(),
    }));
  };

  const handleSubmit = () => {
    const payload = {
      ...formData,
      flag: 'lead_customer',
      lead_id: selectedLead?.id,
    };

    onSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Customer from Lead</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label="Customer Name"
            value={formData.name}
            onChange={handleChange('name')}
            fullWidth
            required
            variant="outlined"
            sx={{ '& .MuiInputBase-root': { borderRadius: '8px' } }}  
          />
          
          <TextField
            label="Email"
            type="email"
            value={formData.email}
            onChange={handleChange('email')}
            fullWidth
            required
            variant="outlined"
            sx={{ '& .MuiInputBase-root': { borderRadius: '8px' } }}  
          />
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField
              label="Password"
              value={formData.password}
              onChange={handleChange('password')}
              fullWidth
              required
              variant="outlined"
              sx={{ '& .MuiInputBase-root': { borderRadius: '8px' } }} 
            />
            <Button
              onClick={handleRegeneratePassword}
              size="small"
              sx={{
                mt: 1,
                borderRadius: '20px',  // Custom button styling
                padding: '6px 12px',
                '&:hover': {
                  backgroundColor: '#1976d2',  // Hover effect
                },
              }}
            >
              Regenerate Password
            </Button>
          </Box>

          {/* Optionally add a helper text */}
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This will create a customer account with the flag "lead_customer".
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!formData.name || !formData.email || !formData.password || processing}
          startIcon={processing ? <CircularProgress size={20} /> : null}
          sx={{
            borderRadius: '8px',  // Button border radius for uniformity
            padding: '8px 16px',
            textTransform: 'none',  // Prevent uppercase
          }}
        >
          Create Customer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCustomerDialog;
